import React from 'react';
import {getFormattedValue, getFormattedDate} from '../utils';
import styles from './Card/Card.module.css';



export default function TableMetric({
	intervalBlue,
	intervalGreen,
	prevValue,
	value,
	type,
	isFavorable
}) {
	const legendColorClass = isFavorable === 1 ? styles.periodLegend_success : styles.periodLegend_alert;



	return (
		<div className={styles.periodTable}>
			<div className={styles.periodRow}>
				<div className={styles.periodCol_legend}>
					<span className={styles.periodLegend}></span>
				</div>
				<div className={styles.periodCol_date}>
					{intervalBlue && getFormattedDate(intervalBlue.start) + ' - ' + getFormattedDate(intervalBlue.end)}
				</div>
				<div className={styles.periodCol_value}>
					{getFormattedValue(prevValue, value, type)}
				</div>
			</div>
			<div className={styles.periodRow}>
				<div className={styles.periodCol_legend}>
					<span className={[styles.periodLegend, legendColorClass].join(' ')}></span>
				</div>
				<div className={styles.periodCol_date}>
					{intervalGreen && getFormattedDate(intervalGreen.start) + ' - ' + getFormattedDate(intervalGreen.end)}
				</div>
				<div className={styles.periodCol_value}>
					{getFormattedValue(value, prevValue, type)}
				</div>
			</div>
		</div>
	);
}
